import config from '@/config/config';
import { del, get, patch, post, put } from '@/helpers/api.helper';
import { parseServiceResponse, ServiceResponseType } from '@/helpers/serviceParsing';
import { useAnonymousUserStore, useUserStore } from '@/store/userStore';
import { getFlowingUserIdByToken } from './auth.service';

const { studio_api } = config.api;

export async function getUserPoint() {
    try {
        const appUserId = await getFlowingUserIdByToken().then(r => {
            return r?.user_id || ''
        }).catch(() => '')
        return parseServiceResponse<{
            userId: string;
            point: number;
        }>(await get(`/point?userId=${appUserId}`, { baseURL: config.api.studio_api }))
    } catch (error) { throw error }
}

interface ShoppingPointType {
    shoppingPoint: number;
}
export async function getShoppingPoint(): Promise<ShoppingPointType> {
    try {
        return await get(`${studio_api}/shopping-point/user-point`).then(r => r.data?.item || {})
    } catch (error) { throw error }
}

export async function getShoppingPointPolicy() {
    try {
        return await get(`${studio_api}/shopping-point/policy`).then(r => r.data?.item || {})
    } catch (error) { throw error }
}

export async function postConvertShoppingPoint(data: {
    point: number;
}) {
    try {
        return await post(`${studio_api}/shopping-point/convert`, data)
    } catch (error) { throw error }
}